import DropdownMenu from "../../../../../../common/Menu/DropdownMenu/DropdownMenu";
import {
    getReasonBelongsTypeThunkAction,
} from "../../../../../../../redux/actions/Requests/LeaveMetadata/thunk/getReasonBelongsType.thunk.action";
import CommentInput from "../../../../../../common/Inputs/CommentInput/CommentInput";
import CustomUploader from "../../../../../../common/CustomUploader/CustomUploader";
import NotificationWindowRequests from "../../../../../../common/NotificationWindowRequests/NotificationWindowRequests";
import {
    emptyCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";
import {
    dropdownSelectionCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/dropdownSelection.currentRequest";
import {
    addCommentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addCommentHandler.currentRequest";
import ShiftAdditionalRestDaysApplication
    from "../../../../../../../frontend.classes/Requests/ShiftAdditionalRestDays.application";
import {
    getRescheduleDaysThunkAction,
} from "../../../../../../../redux/actions/Requests/ShiftAdditionalRestDays/thunk/getRescheduleDays.thunk.action";
import {
    clearShiftDaysAction,
} from "../../../../../../../redux/actions/Requests/ShiftAdditionalRestDays/clearShiftDays.action";
import {
    clearAttachmentsAction,
} from "../../../../../../../redux/actions/Requests/Attachments/clearAttachments.action";
import {
    clearAttachmentsAllowedAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/isAttachmentsAllowed.action";
import {
    isAttachmentsAllowedThunkAction, isAttachmentsAllowedWithReasonThunkAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/isAttachmentsAllowed.thunk.action";
import {
    saveDraftCurrentRequestThunk,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/saveDraft.currentRequest.thunk";
import {
    updateCurrentRequestThunk,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/update.currentRequest.thunk";
import RequestsHelper from "../../../../../../../frontend.services/RequestServices/Requests.helper";
import DatePeriodControlled from "../../../../../../common/Inputs/DatePeriodControlled/DatePeriodControlled";
import { isTerminal } from "../../../../../../../constants";
import { ScrollButton } from "../../../../../../common/componentsTerminal/ScrollButton/ScrollButton";

import BlueButton from "../../../../../../common/Button/BlueButton/BlueButton";

import {
    addPeriodHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addPeriodHandler.currentRequest";

import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import moment from "moment";

isTerminal ? import("./ShiftAdditionalRestDaysTerminal.scss") : import("./ShiftAdditionalRestDays.scss");


const ShiftAdditionalRestDays = ({
    requestOption,
    requestStatus,
    setRequestStatus,
}) => {
    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");

    const dispatch = useDispatch();

    const currentRequest = useSelector(
        (state) => state.requests.currentRequest,
    );
    const reasons = useSelector((state) => state.requests.reasons);
    const shiftDays = useSelector((state) => state.requests.shiftDays);
    const isUserAttachmentsAllowed = useSelector(state => state.requests.isUserAttachmentsAllowed);
    const [notificationWindow, setNotificationWindow] = useState(false);

    function selectReasonClick(event, element, stateProperty) {
        if(stateProperty === "leaveReasonId") {
            let result = false;
            result =dispatch(isAttachmentsAllowedWithReasonThunkAction(
                {
                    requestTypeId: requestOption ,
                    reasonTypeId: element.id,
                }
            ));
            if (result)
                result.then(() => {
                    if (!currentRequest.uid) {
                        dispatch(
                            saveDraftCurrentRequestThunk(
                                { ...currentRequest, leaveReasonId: element.id  },
                                null,
                                null,
                                null,
                                null,
                            ),
                        );
                    } else {
                        dispatch(
                            updateCurrentRequestThunk(
                                { ...currentRequest, leaveReasonId: element.id  },
                                null,
                                null,
                                null,
                            ),
                        );
                    }
                });
        }
        dispatch(
            dropdownSelectionCurrentRequest({ event, element, stateProperty }),
        );
    }

    function setPeriodClick(event, element, stateProperty) {
        const shiftPeriod = shiftDays.find(
            (period) => period.id === element.id,
        );
        const { from, to } = shiftPeriod;
        element.dateFrom = from;
        element.dateTo = to;
        element.reason = element.id;
        stateProperty = "shift";
        dispatch(
            dropdownSelectionCurrentRequest({ event, element, stateProperty }),
        );
    }

    function commentHandler(e) {
        dispatch(addCommentHandlerCurrentRequest(e.target.value));
    }
    function addPeriodHandler(e) {
        dispatch(addPeriodHandlerCurrentRequest());
    }

    useEffect(() => {
        dispatch(getRescheduleDaysThunkAction());
        dispatch(getReasonBelongsTypeThunkAction(requestOption));
        if (!queryId) {
            dispatch(
                emptyCurrentRequest(
                    new ShiftAdditionalRestDaysApplication({
                        leaveTypeId: 13,
                        periods: [{ dateFrom: null, dateTo: null }],
                    }),
                ),
            );
            dispatch(isAttachmentsAllowedThunkAction({requestTypeId: requestOption }));
        } else {
            if (currentRequest && currentRequest?.leaveReasonId) {
                dispatch(isAttachmentsAllowedWithReasonThunkAction(
                    {
                        requestTypeId: currentRequest.leaveTypeId,
                        reasonTypeId: currentRequest.leaveReasonId,
                    }
                ));
            }
        }

        return () => {
            dispatch(clearShiftDaysAction());
            dispatch(clearAttachmentsAction());
            dispatch(clearAttachmentsAllowedAction());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryId]);

    useEffect(() => {
        if (requestStatus && !requestStatus.isSuccess) {
            setNotificationWindow(true);
        }
    }, [requestStatus]);

    // console.log(shiftDays);

    return (
        <div className={"shift-additional-rest-days"}>
            {isTerminal && <ScrollButton />}
            <DropdownMenu
                label={<>Выберите причину переноса дополнительных дней отдыха <span className="required_text"> *</span></>}
                styleName={"reason"}
                listOfOptions={reasons}
                stateProperty={"leaveReasonId"}
                currentRequest={currentRequest}
                selectOptionClick={selectReasonClick}
                dropdownDescription={
                    "Перенос дополнительных дней возможен только в рамках месяца, в котором они были ранее запланированы"
                }
                isValidKey={
                    currentRequest &&
                    currentRequest.isValid &&
                    currentRequest.isValid.leaveReasonId
                        ? currentRequest.isValid.leaveReasonId
                        : false
                }
            />
            {
                currentRequest && currentRequest.leaveReasonId &&
                <DropdownMenu
                    label={
                        <>Выберите период дополнительных дней отдыха для переноса<span className="required_text"> *</span></>
                    }
                    styleName={"reason"}
                    listOfOptions={
                        shiftDays && shiftDays.length ?
                            RequestsHelper.postponeDropdownFabric(shiftDays) :  [{name: "нет отпусков для переноса"}]
                    }
                    stateProperty={"leaveRequestDwhId"}
                    currentRequest={currentRequest}
                    selectOptionClick={setPeriodClick}
                    isValidKey={
                        currentRequest &&
                        currentRequest.isValid &&
                        currentRequest.isValid.leaveRequestDwhId
                            ? currentRequest.isValid.leaveRequestDwhId
                            : false
                    }
                />
            }

            {
                currentRequest
                && currentRequest.leaveRequestDwhId ?
                    (
                        currentRequest &&
                        currentRequest.periods && currentRequest.periods.length ?
                            currentRequest.periods.map((period, index) => {
                                return (
                                    <DatePeriodControlled
                                        allowsMultipleDateRanges={true}
                                        periodsLength={currentRequest.periods.length}
                                        key={uuidv4()}
                                        parentStyle={"postpone-vacation"}
                                        period={period}
                                        index={index}
                                        label={{
                                            from: <>Начало перенесенных дней отдыха<span className="required_text"> *</span></>,
                                            to: <>Окончание перенесенных дней отдыха<span className="required_text"> *</span></>,
                                        }}
                                        datesForRange={{
                                            minFrom: new Date(moment().add(1, "day")),
                                        // minTo: new Da ,
                                        }}
                                    />
                                );
                            }) :
                            <div style={{display: "flex", gap: "15px"}}>
                                <h3 style={{fontSize: "15px"}}>Добавить даты нового  отпуска</h3>
                                <BlueButton
                                    parentStyle={"postpone-vacation"}
                                    handler={addPeriodHandler}
                                />
                            </div>
                    )
                    : null
            }

            <CommentInput
                maxLength={255}
                value={currentRequest && currentRequest.employeeComment}
                changeHandler={commentHandler}
                label={"Комментарий"}
                parentStyle={"postpone-vacation"}
            />
            {isUserAttachmentsAllowed ?
                <CustomUploader /> : null
            }
            <NotificationWindowRequests
                notificationWindowStatus={requestStatus}
                setNotificationWindowStatus={setRequestStatus}
                notificationWindowStyle={notificationWindow}
            />
        </div>
    );
};

export default ShiftAdditionalRestDays;
